export const APPLICATION_JSON = 'application/json';
export const CALL_HISTORY_FILE = 'CallHistory';
export const CONTENT_TYPE = 'Content-Type';
export const CONFIG = 'config';
export const DELETE_CALL_HISTORY_RECORDS_ENDPOINT = 'markAsDeleted';
export const FROM_DATE = '?from';
export const HISTORY = 'history';
export const LIMIT = 50;
export const LINES = 'lines';
export const NUMBER_OF_DAYS = 10;
export const ORG_ID = 'orgId';
export const PEOPLE = 'people';
export const RESPONSE_MESSAGE = 'responseMessage';
export const SET_READ_STATE_SUCCESS_MESSAGE = 'Missed calls are read by the user.';
export const SET_DELETE_CALL_RECORDS_SUCCESS_MESSAGE =
  'Call history records are deleted by the user.';
export const SET_DELETE_CALL_RECORDS_INVALID_DATE_FORMAT_MESSAGE =
  'The provided date is malformed or invalid';
export const SUCCESS_MESSAGE = 'SUCCESS';
export const STATUS_CODE = 'statusCode';
export const USER_SESSIONS = 'userSessions';
export const UPDATE_MISSED_CALLS_ENDPOINT = 'setReadState';
export const UNIFIED_COMMUNICATIONS = 'uc';
export const VERSION_1 = 'v1';

// Method names
export const METHODS = {
  GET_CALL_HISTORY_DATA: 'getCallHistoryData',
  UPDATE_MISSED_CALLS: 'updateMissedCalls',
  FETCH_UCM_LINES_DATA: 'fetchUCMLinesData',
  DELETE_CALL_HISTORY_RECORDS: 'deleteCallHistoryRecords',
};
